/**
 * BEAUTIFULLY DISTURBED atmospheric backdrop.
 * Deep-black base with a slow-breathing crimson glow and drifting smoke.
 * Pure CSS (transform + opacity), GPU-light, disabled under reduced-motion.
 * Sits behind all content; the page stays predominantly black.
 */
export default function TombBackground() {
  return (
    <div className="fixed inset-0 -z-10 pointer-events-none overflow-hidden" aria-hidden="true" style={{ backgroundColor: "#070707" }}>
      <div className="atmo-smoke" />
      <div className="atmo-glow" />
      {/* film grain */}
      <div
        className="absolute inset-0"
        style={{
          opacity: 0.05,
          backgroundImage:
            "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='140' height='140'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='3'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")",
        }}
      />
      {/* vignette */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_transparent_35%,_rgba(0,0,0,0.85)_100%)]" />
    </div>
  );
}
